import { render, staticRenderFns } from "./PcView.vue?vue&type=template&id=61d168f0&scoped=true&"
import script from "./PcView.vue?vue&type=script&lang=ts&"
export * from "./PcView.vue?vue&type=script&lang=ts&"
import style0 from "./PcView.vue?vue&type=style&index=0&id=61d168f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d168f0",
  null
  
)

export default component.exports